<template>
  <button :class="buttonClasses" type="button" @click="handleClick">
    <slot />
  </button>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  /**
   * Active state
   */
  active: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click'])

const buttonClasses = computed(() => [
  'intercom-filter-btn',
  {
    'intercom-filter-btn--active': props.active,
  },
])

const handleClick = (event) => {
  emit('click', event)
}
</script>

<style scoped>
/* ========================================
   INTERCOM FILTER BUTTON (Pill-shaped)
   ======================================== */
.intercom-filter-btn {
  padding: var(--space-1) var(--space-3);
  background: var(--color-gray-100);
  border: 1px solid var(--color-gray-200);
  border-radius: var(--radius-pill);
  font-family: var(--font-family);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-gray-700);
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
}

.intercom-filter-btn:hover:not(.intercom-filter-btn--active) {
  background: var(--color-white);
  border-color: var(--color-blue);
  color: var(--color-blue);
}

.intercom-filter-btn--active {
  background: var(--color-blue);
  color: var(--color-white);
  border-color: var(--color-blue);
}

.intercom-filter-btn--active:hover {
  background: var(--color-blue-hover);
  border-color: var(--color-blue-hover);
}
</style>
